import React from 'react';

// import { useEntitlementsValidation } from './useEntitlementsValidation';

// Temporarily disabled until work to remove legacy YI subscriptions is prioritized
export const EntitlementsValidation: React.FC = () => {
  // useEntitlementsValidation({ runOnMount: true, trigger: 'initial-load', delay: 5000 });
  return null;
};
